import { ReactElement, useState } from 'react';

import './SkillTabBox.scss';

enum SkillTabBoxState {
  FIRST_BOX,
  SECOND_BOX,
}

interface SkillTabBoxProps {
  tabLabels: string[];
  component1?: ReactElement;
  component2?: ReactElement;
}

export default function SkillTabBox({ tabLabels, component1, component2 }: SkillTabBoxProps) {
  const [state, setState] = useState<SkillTabBoxState>(SkillTabBoxState.FIRST_BOX);

  return (
    <div className="skilltabbox-container">
      <div className="tabs-container mb-12">
        <button
          className={`skill-tab ${state === SkillTabBoxState.FIRST_BOX ? 'active' : ''}`}
          onClick={() => {
            setState(SkillTabBoxState.FIRST_BOX);
          }}
        >
          {tabLabels[0]}
        </button>
        <button
          className={`skill-tab ${state === SkillTabBoxState.SECOND_BOX ? 'active' : ''}`}
          onClick={() => {
            setState(SkillTabBoxState.SECOND_BOX);
          }}
        >
          {tabLabels[1]}
        </button>
      </div>
      {state === SkillTabBoxState.FIRST_BOX && component1}
      {state === SkillTabBoxState.SECOND_BOX && component2}
    </div>
  );
}
